import moment from 'moment'

export const customerComplaintSales = {
    id: '',
    distributedToInternal: moment().format('YYYY-MM-DD'),
    receivedDate: moment().format('YYYY-MM-DD'),
    reportedDate: moment().format('YYYY-MM-DD'),
    customerId: '',
    customerName: '',
    address: '',
    pic: '',
    email: '',
    brandId: '',
    brandName: '',
    productId: '',
    productName: '',
    phone: '',
    plantId: '',
    plantName: '',
    packagingId: '',
    packagingName: '',
    blDate: moment().format('YYYY-MM-DD'),
    dispatchDate : moment().format('YYYY-MM-DD'),
    dischargePortId : '',
    dischargePortName : '',
    countryId: '',
    countryName: '',
    containerNo: '',
    modelOfDeliveryId: '',
    modelOfDeliveryName: '',
    conformanceTypeId: '',
    conformanceTypeName: '',
    complaintMediaId: '',
    complaintMediaName: '',
    enclosedId: '',
    enclosedName: '',
    description: '',
    createdBy: '',
    updatedBy: '',
    status: '',
    feedback: '',
    ccSalesAttachment: '',
    ccAreaOwnerAttachment: '',
    closeAction: '',
    transactionStatusCode: '',
    transactionStatusName: '',
    createdAt: moment().format('YYYY-MM-DD'),
    updatedAt: moment().format('YYYY-MM-DD'),
}

export const customerComplaintDetail = {
    customerComplaintId: '',
    po: '',
    so: '',
    batch: '',
    qty: 0,
}

export const customerComplaintQuestion = {
    id: '',
    customerComplaintId: '',
    question: '',
    answer: '',
    answeredAt: moment().format('YYYY-MM-DD'),
    needAttachment: 0,
    attachment: '',
}